import { Layout, CurrentFanbandStats } from 'components/widgets';
import { QuickPollSentAll } from 'components/containers';
import { LINKS } from 'utils/constants';
import { usePathIndicator } from 'hooks';

const QuickPollAlertsSent = () => {
  usePathIndicator([LINKS.quickPoll, LINKS.quickPollSent]);

  return (
    <Layout sidebar={<CurrentFanbandStats />}>
      <QuickPollSentAll />
    </Layout>
  );
};

export default QuickPollAlertsSent;

